// Core
import React, { lazy, useEffect, useState } from 'react';
import {
  Card, Row, Col, Upload, Spin, Tooltip, Modal, notification, Form, Input, Button,
  Divider, Collapse, Badge, message
} from 'antd';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';
import { UploadOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import _ from "lodash";


// App
import {
  pacienteReadAction,
  pacienteServicioCreateAction,
  pacienteServicioListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import PacienteConceptosView from '../conceptos/PacienteConceptos';
import BuscadorProductosServicios from '../conceptos/BuscadorCatalogo';
import { TipoTransaccion } from './../../../config/api/enums';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + '/pacientes/fileUpload.php';

const HistorialClinicoView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registro = useSelector(state => state.PacienteReducer.record);
  const { id } = useParams();
  const [form] = Form.useForm();

  const [nombre, setNombre] = useState('Cargando...');
  const [modalVisible, setModalVisible] = useState(false);
  const [modalPresupuestoVisible, setModalPresupuestoVisible] = useState(false);
  const [buscadorVisible, setBuscadorVisible] = useState(false);
  const [servicio, setServicio] = useState({});

  useEffect(() => {
    if (id) dispatch(pacienteReadAction(id));
    else
      dispatch(pacienteReadAction());
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      let elNombre = registro.nombre.toUpperCase() + ' ' + registro.paterno.toUpperCase() + ' ' + registro.materno.toUpperCase()
      setNombre(elNombre);
    }
  }, [registro]);

  const hideModal = async () => {
    form.resetFields();
    setModalVisible(false);
  };

  const handleSubmit = async values => {
    console.log('handleSubmit.values: ', values);
    const responseApi = await dispatch(pacienteServicioCreateAction(values));
    if (responseApi) {
      let mensaje = 'Nota de evolución registrada exitosamente';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de servicios en compras
      dispatch(pacienteServicioListAction(id, TipoTransaccion.NotaEvolucion));
      hideModal();
      setBuscadorVisible(false);
    } else {
      notification.error({
        message: 'Error al procesar historial clínico',
      });
    }
  };

  const addRecord = () => {
    return (
      <Card style={{ marginTop: '10px' }}>
        <Row gutter={24}>
          <Col span={8}>
            <Form layout="vertical" size="small" name="form_in_modal" onFinish={handleSubmit} form={form}>
            <Form.Item
                name="fecha_ejecucion"
                label="Fecha de visita (temporal)"
                rules={[{ required: false, message: 'Campo obligatorio' }]}
              >
                <Input placeholder="" type='date' />
              </Form.Item>
              <Form.Item
                name="servicio"
                label="Servicio"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                name="diente"
                label="Diente (poner N/A en caso de no aplicar)"
                rules={[{ required: true, message: 'Campo obligatorio' }]}
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                name="tratamiento"
                label="Procedimiento realizado hoy"
                rules={[{ required: true, message: 'Campo obligatorio' }]}
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                name="proximo_tratamiento"
                label="¿Próximo tratamiento?"
                rules={[{ required: true, message: 'Campo obligatorio' }]}
              >
                <Input placeholder="" />
              </Form.Item>              
              <Button size="small" htmlType="Save" type="primary">
                {isLoading ? 'Cargando...' : 'Guardar'}
              </Button>
              <Form.Item name="id" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="idServicio" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="action" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="idPaciente" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="idRecepcionista" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="idDentista" noStyle>
                <Input hidden />
              </Form.Item>
              <Form.Item name="idTipoTransaccion" noStyle>
                <Input hidden />
              </Form.Item>


            </Form>
          </Col>
          <Col span={16}>
            <img src="https://comollenar.com/wp-content/uploads/2020/11/como-llenar-un-odontograma.png" width='90%' />
          </Col>
        </Row>

      </Card>
    );
  };

  const handleServicio = async (registro) => {
    console.log('resupuesto.handleServicio: ', registro.record);
    setServicio(registro.record);
    setModalVisible(true);
    form.setFieldsValue({
      servicio: registro.record.nombre,
      action: 'nota-evolucion',
      id: 0,
      idServicio: registro.record.id,
      idPaciente: id,
      idRecepcionista: 0,
      idDentista: 0,
      idTipoTransaccion: TipoTransaccion.NotaEvolucion,
    });
  };

  const uploadProps = {
    action: API_ENDPOINT,
    accept: ".doc,.docx,.pdf,.png,.jpg,.jpeg",
    showUploadList: false,
    headers: {
      Authorization: `Bearer ${Cookies.get('dcare_access_token')}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} archivo subido correctamente`);
        dispatch(pacienteReadAction(id));
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} error al subir el archivo`);
      }
    },
  };

  const showFile = (identificador) => {

    //console.log("registro.documentos: ", registro.documentos);
    let archivo = _.find(registro.documentos, function (o) { return o.identificador === identificador; });
    console.log("archivo? ", archivo);
    let linkToFile = (<><p>Aún no hay archivo</p></>);
    if (archivo) {
      linkToFile = (<p>
        <a href={archivo.url} target='_blank'><DownloadOutlined /> Descargar archivo</a>

      </p>)
    }
    return linkToFile
  };


  return (
    <>
      <Card>
        <PageHeader
          title="Notas de evolución"
          subTitle={"Historial de consultas del paciente: " + nombre}
          buttons={[
            <Button className="btn-add_new" size="default" key="1" type="primary" onClick={() => setBuscadorVisible(true)}>
              Registrar nota
            </Button>,
            <Button className="btn-add_new" size="default" key="2" type="primary">
              <Link to={`/admin/clinica/pacientes/expediente/${id}`}> Volver al expediente</Link>
            </Button>,
          ]}
        />
        {
          buscadorVisible ? <>
            <p style={{ textAlign: 'center', fontSize: '12px' }}><br />Por favor indica el tratamiento que el paciente recibió</p>
            <BuscadorProductosServicios callbackAction={handleServicio} />
            <Button size="small" type="danger" style={{ float: 'right' }} onClick={() => { setBuscadorVisible(false) }}>
              Cancelar
            </Button>
          </> : <></>

        }
        <br />
        {
          !buscadorVisible ? <>
            <Button type="ghost" onClick={() => { setModalPresupuestoVisible(true) }}>
              <Badge count={5} color='blue' size='24' offset={[10, 0]} >
                <strong>Consultar presupuesto</strong>
              </Badge>
            </Button><br />
            <PacienteConceptosView pacienteId={id} tipoTransaccionId={TipoTransaccion.NotaEvolucion} vista='historial' />
          </> : <></>
        }

      </Card>
      <Cards headless>
        <p><strong>Foto de las notas de evolución</strong></p>
        <Row gutter={24}>
          <Col lg={6}>
            {showFile('notas_evolucion_paciente')}
          </Col>
          <Col>
            <Upload name='notas_evolucion_paciente' data={{ pacienteId: id, nombreArchivo: 'notas_evolucion_paciente' }}  {...uploadProps}>

              <Button icon={<UploadOutlined />}>Subir archivo</Button>
            </Upload>
          </Col>
        </Row>
      </Cards>
      <Modal title="REGISTRAR NOTA DE EVOLUCIÓN" visible={modalVisible} onCancel={hideModal} footer={[]} width='80%'>
        {addRecord()}
      </Modal>
      <Modal title="Presupuesto" visible={modalPresupuestoVisible} onCancel={() => setModalPresupuestoVisible(false)} footer={[]} width='80%'>
        <PacienteConceptosView pacienteId={id} tipoTransaccionId={TipoTransaccion.Presupuesto} vista='presupuesto' />
      </Modal>
    </>
  );
};

export default HistorialClinicoView;
